import { BaseStyleId, DynamicStyleId, StaticStyleId } from '../../types/Styles';

export const baseMapStyles: BaseStyleId[] = [
  'alltrailsOutdoorsV3', //   AllTrails V2
  'alltrailsSatelliteV2', //  Satellite V2
  'googleSatellite', //       Google satelllite   ** admin only **
  'worldparks', //            Terrain
  'roadmap', //               Road
  'openstreet', //            OSM
  'opencycle', //             OCM
  'topo', //                  USGS
  'ignPlan', //               IGN Plan
  'ignScan', //               IGN Scan 25
  'worldtopo', //             Terrain (legacy)    ** admin only **
  'osGreatBritain', //        OS Great Britain
  'adminBasemap' //           Admin maps          ** admin only **
];

export const layerOverlayStyles: (StaticStyleId | DynamicStyleId)[] = ['publicLands', 'privateLands'];
export const terrainOverlayStyles: (StaticStyleId | DynamicStyleId)[] = ['slopeAngle', 'highDefTerrain'];

// Personal first → renders above Community per Figma 12994:47895.
export const heatmapStyles: DynamicStyleId[] = ['personalHeatmap', 'newHeatmap', 'trailHeatmap'];

export const conditionsStyles: (StaticStyleId | DynamicStyleId)[] = [
  'precipitation',
  'temperature',
  'snowDepth',
  'groundConditions',
  'fallFoliage',
  'wildfire'
];

export const extraStyles: (StaticStyleId | DynamicStyleId)[] = [
  'photoHeatmap', //        Photo hotspots      ** admin only **
  'recordingStart', //      Activity starting points ** admin only **
  'recordingEnd', //        Activity endpoints  ** admin only **
  'heatmap', //             Heatmap             ** admin only **
  'surfaceType', //         Surface type
  'userWaypoints', //       Your waypoints
  'communityWaypoints', //  Community waypoints
  'savedRoutePolyline', //  Previously saved route (peak-only, while editing a custom route)
  'nearbyTrails', //        Nearby trails
  'adminTrailheads', //     Trailheads          ** admin only **
  'recordingsAll', //       Recordings all      ** admin only **
  'recordingsPop', //       Recordings popular  ** admin only **
  'pendingTrails', //       Pending trails      ** admin only **
  'after', //               Last 60 days        ** admin only **
  'limit', //               Most recent 50      ** admin only **
  'photos', //              Photos
  // h3 heatmap
  // low traffic
  'mapsAll', //             Maps all            ** admin only **
  'contribs', //            Contrib VRs         ** admin only **
  'adminOverlay', //        Custom overlay      ** admin only **
  'geoBoundaries', //       Polygons            ** admin only **
  'waymarkedHiking', //     Waymarked hiking
  'waymarkedMTB', //        Waymarked MTB
  'waymarkedCycling', //    Waymarked cycling
  'distanceMarkers', //     Distance markers
  'photospot' //            Photospot           ** admin only **
];

/**
 * Order of style ids within each grouped section of the extras.
 * Items not listed here aren't rendered in the grouped layout.
 */
export type DetailStyleGroupId = 'community-content' | 'on-trail-details' | 'nearby-trails-routes';
export const detailStyleGroups: { id: DetailStyleGroupId; styleIds: (StaticStyleId | DynamicStyleId)[] }[] = [
  { id: 'community-content', styleIds: ['userWaypoints', 'communityWaypoints', 'communityActivity'] },
  { id: 'on-trail-details', styleIds: ['photos', 'surfaceType', 'distanceMarkers'] },
  {
    id: 'nearby-trails-routes',
    styleIds: ['savedRoutePolyline', 'nearbyTrails', 'waymarkedHiking', 'waymarkedCycling', 'waymarkedMTB']
  }
];
